import { render, staticRenderFns } from "./ShowSoundBox.vue?vue&type=template&id=56d022b4"
import script from "./ShowSoundBox.vue?vue&type=script&lang=js"
export * from "./ShowSoundBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports